// Português (Portugal) — mirrors en.js key for key. pt distinguishes
// one/other in CLDR.
const ptPT = {
  // ===== shared =====
  'common.createPlan': 'Criar plano',
  'common.save': 'Guardar',
  'common.cancel': 'Cancelar',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.retry': 'Tentar novamente',
  'common.activate': 'Ativar',
  'common.deactivate': 'Desativar',
  'common.enabled': 'Ativo',
  'common.disabled': 'Inativo',
  'common.viewTerms': 'Ver termos',
  'common.untitledPlan': 'Plano sem título',
  'common.savedToast': 'Guardado com êxito',

  // ===== nav / chrome =====
  'nav.home': 'Início',
  'nav.plans': 'Planos',
  'nav.settings': 'Definições',

  'mismatch.title': 'Ambiente de implementação não corresponde',
  'mismatch.body': 'Esta compilação do frontend chama {apiBase}, mas está a ser servida a partir de {hostname} (esperado: {expected}).',
  'mismatch.contact': 'Contacte o suporte técnico — trata-se de um erro de configuração da implementação, não de um problema com a sua conta.',

  'install.title': 'Não foi possível ligar ao Shopify',
  'install.body': 'Verifique se o backend está em execução e se a respetiva SHOPIFY_API_KEY corresponde ao client_id da app em shopify.app.toml.',
  'install.retry': 'Tentar novamente',

  'chrome.loadingBrand': 'A carregar o FlexCover…',
  'error.title': 'Ocorreu um erro',
  'error.reload': 'Recarregar',

  'support.badge': 'Vista de suporte',
  'support.shopUnknown': '(loja desconhecida)',
  'support.expired': 'Token expirado — gere novamente na consola de suporte',
  'support.validUntil': 'Token válido até {time}',
  'support.exit': 'Sair',

  // ===== Home =====
  'home.title': 'Bem-vindo ao FlexCover: Protection Plans 👋',
  'home.last30days': 'Últimos 30 dias',
  'home.loadingChart': 'A carregar o gráfico',
  'home.loadingOverview': 'A carregar a descrição geral',
  'home.statOrders': 'Encomendas com planos',
  'home.statRevenue': 'Receita total dos planos',
  'home.gettingStarted': 'Começar',
  'home.allSet': 'Tudo pronto 🎉',
  'home.completed': '{done} de {total} concluídos',
  'home.step1.title': 'Crie o seu primeiro plano',
  'home.step1.desc': 'Defina o preço, a cobertura e a apresentação no carrinho da sua oferta de proteção.',
  'home.step2.title': 'Ative o bloco da app',
  'home.step2.desc': 'Ative o bloco FlexCover: Protection Plans para que o widget apareça no seu carrinho.',
  'home.step2.enable': 'Ativar bloco da app',
  'home.step2.check': 'Verificar estado',
  'home.step3.title': 'Obtenha a sua primeira encomenda protegida',
  'home.step3.desc': 'Com o widget ativo, os clientes acrescentam um plano no carrinho — os totais aparecem nos cartões acima.',
  'home.appEmbed': 'Bloco da app',
  'home.checkingEmbed': 'A verificar o estado do bloco da app',
  'home.embedEnabledBody': 'O widget de proteção está ativo na sua loja.',
  'home.embedTheme': '(tema: {theme})',
  'home.embedDisabledBody': 'A app não está atualmente ativa na sua loja.',
  'home.embedUnknown': 'Desconhecido',
  'home.embedUnknownBody': 'O estado da loja ficará disponível quando a app estiver ligada a uma loja.',
  'home.embedUnknownReason': 'Não foi possível ler o seu tema neste momento.',
  'home.enableEmbedHint': 'No admin do Shopify, vá a Loja online → Temas → Personalizar → Blocos da app e ative o FlexCover: Protection Plans.',
  'home.learnMorePrefix': 'Saiba mais sobre ',
  'home.learnMoreLink': 'como usar os planos de proteção',

  // ===== Plans list =====
  'plans.title': 'Planos',
  'plans.loading': 'A carregar planos',
  'plans.errorTitle': 'Não foi possível carregar os planos',
  'plans.empty.heading': 'Crie o seu primeiro plano de proteção',
  'plans.empty.body': 'Ofereça proteção de envio, garantias alargadas, seguro de devolução e cobertura personalizada — tudo com os preços que decidir.',
  'plans.loadDemo': 'Carregar planos de demonstração',
  'plans.demoLoaded': 'Planos de demonstração carregados',
  'plans.demoFailed': 'Falha ao carregar os planos de demonstração: {message}',
  'plans.filterPlaceholder': 'Filtrar planos',
  'plans.addFilter': 'Adicionar filtro',
  'plans.statusHeading': 'Estado',
  'plans.typeHeading': 'Tipo de proteção',
  'plans.statusActive': 'Ativo',
  'plans.statusInactive': 'Inativo',
  'plans.showing_one': 'A mostrar {count} plano',
  'plans.showing_other': 'A mostrar {count} planos',
  'plans.sortBy': 'Ordenar por',
  'plans.selectAll': 'Selecionar todos os planos',
  'plans.selectedCount': '{count} selecionados',
  'plans.bulkDeleted_one': '{count} plano eliminado',
  'plans.bulkDeleted_other': '{count} planos eliminados',
  'plans.bulkActivated_one': '{count} plano ativado',
  'plans.bulkActivated_other': '{count} planos ativados',
  'plans.bulkDeactivated_one': '{count} plano desativado',
  'plans.bulkDeactivated_other': '{count} planos desativados',
  'plans.deleteBulkFailed': 'Falha ao eliminar: {message}',
  'plans.updateBulkFailed': 'Falha ao atualizar: {message}',
  'plans.activated': 'Plano ativado',
  'plans.deactivated': 'Plano desativado',
  'plans.updateFailed': 'Falha ao atualizar o plano: {message}',
  'plans.deleted': 'Plano eliminado',
  'plans.deleteFailed': 'Falha ao eliminar o plano: {message}',
  'plans.actionsFor': 'Ações para {name}',
  'plans.activatePlan': 'Ativar {name}',
  'plans.deactivatePlan': 'Desativar {name}',
  'plans.onlineStore': 'Loja online',
  'plans.optional': 'Opcional',
  'plans.automatic': 'Automático',
  'plans.noMatch': 'Nenhum plano corresponde à sua pesquisa ou filtros.',
  'plans.deleteTitle': 'Eliminar o plano de proteção?',
  'plans.deleteBody': 'será removido imediatamente da sua loja. Os clientes deixarão de ver esta opção de proteção.',
  'plans.helpPrefix': 'Precisa de ajuda? ',
  'plans.helpLink': 'Fale connosco',
  'plans.helpSuffix': ' ou consulte a documentação e os tutoriais da app.',

  'sort.date': 'Data (mais recentes primeiro)',
  'sort.name': 'Nome (A–Z)',
  'sort.sortOrder': 'Ordem no carrinho',
  'sort.price': 'Preço (crescente)',

  'planType.shipping_protection': 'Proteção de envio',
  'planType.warranty': 'Garantia',
  'planType.return_insurance': 'Seguro de devolução',
  'planType.custom': 'Proteção personalizada',
  'planTypeShort.shipping_protection': 'Envio',
  'planTypeShort.warranty': 'Garantia',
  'planTypeShort.return_insurance': 'Devolução',
  'planTypeShort.custom': 'Personalizado',
  'priceType.fixed': 'Montante fixo',
  'priceType.percentage': 'Percentagem da encomenda',

  // ===== Plan editor page shell =====
  'plan.pageTitle': 'Plano de proteção',
  'plan.loading': 'A carregar o plano',
  'plan.notFound.heading': 'Plano não encontrado',
  'plan.notFound.body': 'Este plano de proteção pode ter sido eliminado.',
  'plan.backToPlans': 'Voltar aos planos',
  'plan.newTitle': 'Novo plano de proteção',
  'plan.newSubtitle': 'Configure o preço e a apresentação no carrinho e, em seguida, crie o plano',
  'plan.subtitle': 'As alterações aplicam-se à sua loja depois de guardar',
  'plan.statusTitle': 'Estado do plano',
  'plan.saveFailed': 'Falha ao guardar o plano: {message}',

  // ===== Plan editor form =====
  'form.section.type': 'Tipo de proteção',
  'form.section.basics': 'Dados básicos do plano',
  'form.section.pricing': 'Preços — {type}',
  'form.pricingFallback': 'Proteção',
  'form.section.appearance': 'Aparência',
  'form.section.fulfillment': 'Expedição',

  'form.type.shipping_protection': 'Proteção de envio',
  'form.type.shipping_protection.help': 'Protege a encomenda do cliente contra perda, danos ou roubo durante o envio.',
  'form.type.warranty': 'Garantia',
  'form.type.warranty.help': 'Cobre defeitos de fabrico e desgaste normal por um período fixo.',
  'form.type.return_insurance': 'Seguro de devolução',
  'form.type.return_insurance.help': 'Permite aos clientes devolver artigos dentro de um prazo com reembolso total.',
  'form.type.custom': 'Proteção personalizada',
  'form.type.custom.help': 'A sua própria mensagem de cobertura personalizada.',

  'form.defaults.untitledPlan': 'Plano sem título',
  'form.defaults.viewTerms': 'Ver termos',
  'form.defaults.shipping_protection.displayName': 'Proteção de envio',
  'form.defaults.shipping_protection.description': 'Protege a sua encomenda contra perda, danos e roubo durante o envio.',
  'form.defaults.warranty.displayName': 'Garantia alargada',
  'form.defaults.warranty.description': 'Cobre defeitos de fabrico e desgaste normal durante 2 anos.',
  'form.defaults.return_insurance.displayName': 'Seguro de devolução',
  'form.defaults.return_insurance.description': 'Devolva qualquer artigo no prazo de 14 dias com reembolso total.',
  'form.defaults.custom.displayName': 'Plano de proteção',
  'form.defaults.custom.description': 'Adicione proteção à sua encomenda.',

  'form.lang.select': 'Selecionar idioma',
  'form.lang.default': '{name} (predefinido)',
  'form.translated': '(traduzido)',

  'form.field.planName.label': 'Nome do plano (interno)',
  'form.field.planName.help': 'Apenas para sua referência — os clientes nunca o veem',
  'form.field.nameRequired': 'O nome interno é obrigatório',
  'form.field.displayName.label': 'Nome apresentado',
  'form.field.displayNameRequired': 'O nome apresentado é obrigatório',
  'form.field.displayName.placeholder': 'Nome apresentado',
  'form.field.displayName.help': 'Mostrado aos clientes no carrinho e no checkout',
  'form.field.displayName.helpPreset': 'Mostrado aos clientes que navegam em {lang}',
  'form.field.displayName.helpPresetFallback': 'Mostrado aos clientes que navegam em {lang} — os campos vazios recorrem ao {primary}',
  'form.field.description.label': 'Descrição',
  'form.field.description.placeholder': 'Descrição',
  'form.field.description.help': 'Breve descrição para os clientes apresentada sob o nome do plano',
  'form.field.disabledDescription.label': 'Descrição quando não selecionado',
  'form.field.disabledDescription.placeholder': 'Opcional — apresentado quando o plano não está selecionado',
  'form.field.disabledDescription.help': 'Apresentado quando a caixa do plano está desmarcada (se vazio, recorre à descrição acima)',
  'form.field.footer.label': 'Rodapé',
  'form.field.footerText.label': 'Texto do rodapé',
  'form.field.footerLink.label': 'Link do rodapé',
  'form.field.footerLink.help': 'Destino do link do texto do rodapé',

  'form.price.type.label': 'Tipo de preço',
  'form.price.fixed': 'Montante ($)',
  'form.price.percentage': 'Percentagem (%)',
  'form.price.advanced': 'Definição avançada',
  'form.price.pctSummary': '{pct}% do valor da encomenda, a partir de ${min} em incrementos de ${inc} até ${max} — {count} variantes no produto do plano',
  'form.price.tiersSummary_one': 'O produto do plano recebe 1 variante em {base} mais {count} variante por intervalos para as regras de valor do carrinho',
  'form.price.tiersSummary_other': 'O produto do plano recebe 1 variante em {base} mais {count} variantes por intervalos para as regras de valor do carrinho',

  'form.validation.priceRequired': 'Introduza um valor superior a 0',
  'form.validation.priceMax100': 'A percentagem não pode exceder 100',
  'form.validation.warrantyYears': 'Introduza uma duração entre 1 e 5 anos',
  'form.validation.returnDays': 'Introduza um prazo entre 7 e 365 dias',
  'form.validation.maxGreaterThanMin': 'O máximo deve ser superior ao mínimo',
  'form.validation.variantIdNumeric': 'O ID da variante deve ser numérico (o ID da variante oculta do plano)',

  'form.icon.label': 'Ícone',
  'form.icon.useEmoji': 'Usar {emoji} como ícone do plano',
  'form.icon.removeCustom': 'Remover o ícone personalizado e usar o ícone de escudo',
  'form.icon.upload': 'Carregar uma imagem de ícone personalizada',
  'form.icon.uploadButton': 'Carregar',
  'form.icon.uploading': 'A carregar o ícone',
  'form.icon.uploadHelp': 'Carregue o seu próprio ícone — PNG, JPEG, GIF ou WebP, até 5 MB.',
  'form.icon.error.notImage': 'Escolha um ficheiro de imagem (PNG, JPEG, GIF ou WebP).',
  'form.icon.error.tooLarge': 'A imagem deve ter 5 MB ou menos.',

  'form.fulfillment.intro': 'Escolha quando o produto de proteção é marcado como expedido.',
  'form.fulfillment.manually': 'Expedir manualmente',
  'form.fulfillment.first_item': 'Marcar como expedido quando o primeiro artigo da encomenda for expedido',
  'form.fulfillment.all_items': 'Marcar como expedido quando todos os outros artigos da encomenda forem expedidos',
  'form.fulfillment.immediately': 'Marcar como expedido imediatamente após a criação da encomenda',

  'form.adv.title': 'Definição avançada',
  'form.adv.minPrice': 'Preço mínimo',
  'form.adv.minPriceHelp': 'O preço da primeira variante — a tarifa mínima cobrada pelo plano',
  'form.adv.increment': 'Valor do incremento',
  'form.adv.incrementHelp': 'Escalão de preço entre as variantes geradas',
  'form.adv.maxPriceLabel': 'Preço máximo: ',
  'form.adv.explanation': 'O produto do plano é gerado com {buckets} variantes: o preço mínimo {min} ocupa uma variante e as restantes {rest} variantes sobem em incrementos de {inc}, até um preço máximo de {max}. No checkout, o cliente paga a primeira variante com preço igual ou superior a {pct}% do subtotal do carrinho — um carrinho de $100 a 2% aponta para $2.00, pelo que se aplica a variante de $3.01. ',
  'form.learnMore': 'Saber mais',

  'form.tiers.title': 'Definir preço por valor do carrinho',
  'form.tiers.minCol': 'Valor mínimo do carrinho',
  'form.tiers.maxCol': 'Valor máximo do carrinho',
  'form.tiers.priceCol': 'Preço da proteção',
  'form.tiers.addTier': 'Adicionar novo escalão',
  'form.tiers.deleteTier': 'Eliminar escalão {index}',
  'form.tiers.explanation': 'Cada regra precisa de um mínimo, um máximo e um preço (as regras podem sobrepor-se — aplica-se a primeira regra correspondente). Cada regra torna-se a sua própria variante no produto do plano. Se o total do carrinho não corresponder a nenhuma regra, aplica-se o preço fixo da definição principal. ',
  'form.tiers.error.minRequired': 'O valor mínimo do carrinho é obrigatório',
  'form.tiers.error.maxRequired': 'O valor máximo do carrinho é obrigatório',
  'form.tiers.error.priceRequired': 'O preço da proteção é obrigatório',
  'form.tiers.error.pricePositive': 'O preço deve ser superior a 0',
  'form.tiers.error.minMax': 'O mínimo deve ser menor ou igual ao máximo',

  // ===== Save bar =====
  'savebar.unsavedChanges': 'Alterações não guardadas',
  'savebar.discard': 'Descartar',
  'savebar.saving': 'A guardar…',

  // ===== Preview panel =====
  'preview.title': 'Pré-visualização',
  'preview.simulatedSubtotal': 'Subtotal simulado do carrinho',
  'preview.cart': 'Carrinho',
  'preview.product': 'PRODUTO',
  'preview.total': 'TOTAL',
  'preview.subtotal': 'Subtotal',
  'preview.checkout': 'Finalizar compra',
  'preview.noPlans': 'Ainda não há planos ativos — os clientes não verão este widget.',
  'preview.autoAdded': 'Adicionado automaticamente',
  'preview.unsaved': 'Não guardado',

  // ===== Settings page =====
  'settings.title': 'Definições',
  'settings.language.title': 'Preferência de idioma',
  'settings.language.help': 'Quando visita o FlexCover, este é o idioma apresentado para si. O idioma da sua loja não é afetado.',
  'settings.language.label': 'Idioma',
  'settings.language.updated': 'Idioma atualizado',
  'settings.language.saveFailed': 'Falha ao guardar a preferência de idioma: {message}'
};

export default ptPT;
